import React from 'react'
import Framework from '../components/Framework'
import MainMenu from '../components/MainMenu'
import TagsList from '../containers/TagsList'
import {  Button } from 'semantic-ui-react'
import ModalWrapper from '../components/ModalWrapper'
import TagForm from '../containers/TagForm'


class TagsPage extends React.Component {
  state = {
    modalOpen: false,
    filterData: undefined
  }

  onCreateClick = () => {
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    this.setState({
      modalOpen: false
    })
  }

  onFilterChange = (filterData) => {
    this.setState({
      filterData
    })
  }

  render() {
    return (
      <Framework>
        <div style={{
        display: 'flex'
        }}>
          <div>
            <MainMenu current='tags' />
          </div>
          <div>
            <ModalWrapper headerIcon='plus' headerContent='Create tag' onClose={this.closeModal} open={this.state.modalOpen} render={
              (close) => (
                <TagForm onSuccess={() => {
                  this.closeModal()
                  this.props.loadTags(this.state.filterData)
                }}
                />
              )
            }/>
            <Button primary onClick={this.onCreateClick}>Create</Button>
            <TagsList onFilterChange={this.onFilterChange} />
          </div>
        </div>
      </Framework>
      )
  }
}

export default TagsPage
